import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Service } from '@masar/common/models';
import { permissionList } from '@masar/common/constants';

@Component({
    selector: 'app-service-link',
    templateUrl: './service-link.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class ServiceLinkComponent {
    @Input() public item: Service;
    public permissionList = permissionList;
}
